import { SHIPPING_METHOD_TYPE } from '@constants'
import { type ValueOf } from '@dni-types/utilities/value-of'

const SF_STORE_TYPE = {
  SF_BUSINESS_POINT: SHIPPING_METHOD_TYPE.SF_BUSINESS_POINT,
  SF_LOCKER: SHIPPING_METHOD_TYPE.SF_LOCKER,
  SF_PARTNER_STORE: SHIPPING_METHOD_TYPE.SF_PARTNER_STORE,
} as const

type SfStoreType = ValueOf<typeof SF_STORE_TYPE>

function isSfShippingType(shippingMethodType: string): shippingMethodType is SfStoreType {
  return (Object.values(SF_STORE_TYPE) as string[]).includes(shippingMethodType)
}

const SF_SHIPPING_METHOD_CODE_TO_TYPE: Record<string, SfStoreType> = {
  SFSP: SF_STORE_TYPE.SF_BUSINESS_POINT,
  SFLK: SF_STORE_TYPE.SF_LOCKER,
  SFCV: SF_STORE_TYPE.SF_PARTNER_STORE,
}

/**
 * 把各種來源的 SF 運送方式字串正規化成 SfStoreType，非順豐回 null。
 * 支援三種來源格式：
 * 1. enum 值：sf_business_point
 * 2. WooCommerce slug：pickup_sf_business_point_hk
 * 3. 配送方式代碼：SFSP / SFLK / SFCV
 */
export function resolveSfStoreType(shippingMethod: string): SfStoreType | null {
  if (isSfShippingType(shippingMethod)) return shippingMethod
  const codeType = SF_SHIPPING_METHOD_CODE_TO_TYPE[shippingMethod]
  if (codeType) return codeType
  // slug 必須頭尾都符合 pickup_…_hk 才取中段，避免 sf_locker_hk、pickup_sf_locker 這種缺一邊的字串被誤判
  const candidate = shippingMethod.match(/^pickup_(.+)_hk$/)?.[1]
  return candidate && isSfShippingType(candidate) ? candidate : null
}
